(function($) {

  var $item = $('.js-inverse-hover-item');
  var $inputToggle = $('.js-inverse-hover-input-toggle');

  $inputToggle.change(function(){
    $item.removeClass('c-cards__item--selected');
    $(this).siblings($item).addClass('c-cards__item--selected');

    $inputToggle.attr('aria-checked', false);
    if( $(this).is(':checked')) {
      $(this).attr('aria-checked', true);
      $('.c-cards__item').not('.c-cards__item--selected').css('opacity', '0.3');
      $('.c-cards__item--selected').css('opacity', '1');
    } else {
      $(this).attr('aria-checked', false);
    }
    
  });

})(jQuery); 